
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';

import Text from '../../common/client/components/Text';

import theme from '../common/theme';
import ValueList from '../ValueList';

const ProjectItem = (props) => {
    const classNames = mergeStyleSets({
        title: {
            fontWeight: 'bold',
            color: '#333333',
            paddingBottom: '4px'
        },
        container: {
            width: props.width,
            position: 'relative',
            float: 'left'
        },
        item: {
            backgroundColor: theme.fabricTheme.palette.bgDefault,
            cursor: 'pointer',
            height: '60px',
            margin: '8px',
            padding: '8px',
            selectors: {
                ':hover': {
                    backgroundColor: theme.fabricTheme.palette.bgHover
                }
            }
        }
    });

    return (
        <div className={classNames.container}>
            <div className={classNames.item} onClick={props.onClick}>
                <div className={classNames.title}>
                    <Text large bold>{props.project.title}</Text>
                </div>
                <ValueList
                    values={[
                        {
                            id: 'owner',
                            title: 'Vlastník projektu',
                            titleStyle: {width: '150px'},
                            value: props.project.owner
                        }
                    ]}
                />
            </div>
        </div>
    );
}

export default ProjectItem;
